export const BASE_ANNUAL_MEMBERSHIP_PRICE = 119.88



// WEBPACK FOOTER //
// ./src/store/store/store.constants.js